module.exports = __webpack_public_path__ + "static/img/WisdomSiteSystem.37ce5bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/WisdomSiteSystem.png
// module id = VNAq
// module chunks = 12